import * as q from "react";
import Ve, { createContext as kn, useContext as Rn, useState as K, useRef as Q, useEffect as $, useCallback as et, useMemo as Cn } from "react";
import Tn from "@arcgis/core/layers/GraphicsLayer.js";
import xn from "@arcgis/core/Graphic";
import * as Er from "@arcgis/core/geometry/support/jsonUtils";
import { useTranslation as On } from "react-i18next";
import { CalciteTooltip as Dn } from "@esri/calcite-components-react/dist";
import Jt from "@arcgis/core/Map";
import Mn from "@arcgis/core/WebMap";
import Pn from "@arcgis/core/WebScene";
import Nn from "@arcgis/core/views/MapView";
import An from "@arcgis/core/views/SceneView";
import X from "@arcgis/core/Basemap";
import ve from "@arcgis/core/layers/VectorTileLayer";
import wr from "@arcgis/core/geometry/Point";
import { createLogger as we } from "@origo/logger";
import In from "@arcgis/core/layers/TileLayer";
import jn from "@arcgis/core/layers/MapImageLayer";
import Ln from "@arcgis/core/layers/SceneLayer";
import Vn from "@arcgis/core/layers/ElevationLayer";
import zn from "@arcgis/core/Ground";
import Fn from "@arcgis/core/widgets/BasemapGallery/support/LocalBasemapsSource";
import Sr from "@arcgis/core/widgets/Search/LocatorSearchSource";
import kr from "@arcgis/core/layers/FeatureLayer";
import * as Z from "@arcgis/core/core/reactiveUtils";
import $n from "@arcgis/core/widgets/Search";
import ze from "@arcgis/core/widgets/Expand";
import Hn from "@arcgis/core/widgets/BasemapGallery";
import Wn from "@arcgis/core/widgets/AreaMeasurement2D";
import Un from "@arcgis/core/widgets/AreaMeasurement3D";
import Bn from "@arcgis/core/widgets/Daylight";
import Gn from "@arcgis/core/widgets/ShadowCast";
import Yn from "@arcgis/core/widgets/Fullscreen";
import Kn from "@arcgis/core/widgets/ScaleBar";
import Ne from "@arcgis/core/support/actions/ActionButton";
var dt = { exports: {} }, ye = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qt;
function Jn() {
  if (qt)
    return ye;
  qt = 1;
  var e = Ve, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(s, l, u) {
    var f, m = {}, g = null, h = null;
    u !== void 0 && (g = "" + u), l.key !== void 0 && (g = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (f in l)
      n.call(l, f) && !a.hasOwnProperty(f) && (m[f] = l[f]);
    if (s && s.defaultProps)
      for (f in l = s.defaultProps, l)
        m[f] === void 0 && (m[f] = l[f]);
    return { $$typeof: t, type: s, key: g, ref: h, props: m, _owner: i.current };
  }
  return ye.Fragment = r, ye.jsx = c, ye.jsxs = c, ye;
}
var he = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xt;
function qn() {
  return Xt || (Xt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ve, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), y = Symbol.iterator, v = "@@iterator";
    function O(o) {
      if (o === null || typeof o != "object")
        return null;
      var d = y && o[y] || o[v];
      return typeof d == "function" ? d : null;
    }
    var M = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(o) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), _ = 1; _ < d; _++)
          p[_ - 1] = arguments[_];
        E("error", o, p);
      }
    }
    function E(o, d, p) {
      {
        var _ = M.ReactDebugCurrentFrame, T = _.getStackAddendum();
        T !== "" && (d += "%s", p = p.concat([T]));
        var x = p.map(function(R) {
          return String(R);
        });
        x.unshift("Warning: " + d), Function.prototype.apply.call(console[o], console, x);
      }
    }
    var w = !1, b = !1, C = !1, D = !1, P = !1, U;
    U = Symbol.for("react.module.reference");
    function Y(o) {
      return !!(typeof o == "string" || typeof o == "function" || o === n || o === a || P || o === i || o === u || o === f || D || o === h || w || b || C || typeof o == "object" && o !== null && (o.$$typeof === g || o.$$typeof === m || o.$$typeof === c || o.$$typeof === s || o.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      o.$$typeof === U || o.getModuleId !== void 0));
    }
    function se(o, d, p) {
      var _ = o.displayName;
      if (_)
        return _;
      var T = d.displayName || d.name || "";
      return T !== "" ? p + "(" + T + ")" : p;
    }
    function ke(o) {
      return o.displayName || "Context";
    }
    function A(o) {
      if (o == null)
        return null;
      if (typeof o.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof o == "function")
        return o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case s:
            var d = o;
            return ke(d) + ".Consumer";
          case c:
            var p = o;
            return ke(p._context) + ".Provider";
          case l:
            return se(o, o.render, "ForwardRef");
          case m:
            var _ = o.displayName || null;
            return _ !== null ? _ : A(o.type) || "Memo";
          case g: {
            var T = o, x = T._payload, R = T._init;
            try {
              return A(R(x));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, ce, le, Ue, Dt, Mt, Pt, Nt;
    function At() {
    }
    At.__reactDisabledLog = !0;
    function qr() {
      {
        if (ee === 0) {
          ce = console.log, le = console.info, Ue = console.warn, Dt = console.error, Mt = console.group, Pt = console.groupCollapsed, Nt = console.groupEnd;
          var o = {
            configurable: !0,
            enumerable: !0,
            value: At,
            writable: !0
          };
          Object.defineProperties(console, {
            info: o,
            log: o,
            warn: o,
            error: o,
            group: o,
            groupCollapsed: o,
            groupEnd: o
          });
        }
        ee++;
      }
    }
    function Xr() {
      {
        if (ee--, ee === 0) {
          var o = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, o, {
              value: ce
            }),
            info: B({}, o, {
              value: le
            }),
            warn: B({}, o, {
              value: Ue
            }),
            error: B({}, o, {
              value: Dt
            }),
            group: B({}, o, {
              value: Mt
            }),
            groupCollapsed: B({}, o, {
              value: Pt
            }),
            groupEnd: B({}, o, {
              value: Nt
            })
          });
        }
        ee < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Be = M.ReactCurrentDispatcher, Ge;
    function Re(o, d, p) {
      {
        if (Ge === void 0)
          try {
            throw Error();
          } catch (T) {
            var _ = T.stack.trim().match(/\n( *(at )?)/);
            Ge = _ && _[1] || "";
          }
        return `
` + Ge + o;
      }
    }
    var Ye = !1, Ce;
    {
      var Qr = typeof WeakMap == "function" ? WeakMap : Map;
      Ce = new Qr();
    }
    function It(o, d) {
      if (!o || Ye)
        return "";
      {
        var p = Ce.get(o);
        if (p !== void 0)
          return p;
      }
      var _;
      Ye = !0;
      var T = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var x;
      x = Be.current, Be.current = null, qr();
      try {
        if (d) {
          var R = function() {
            throw Error();
          };
          if (Object.defineProperty(R.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(R, []);
            } catch (z) {
              _ = z;
            }
            Reflect.construct(o, [], R);
          } else {
            try {
              R.call();
            } catch (z) {
              _ = z;
            }
            o.call(R.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (z) {
            _ = z;
          }
          o();
        }
      } catch (z) {
        if (z && _ && typeof z.stack == "string") {
          for (var k = z.stack.split(`
`), V = _.stack.split(`
`), N = k.length - 1, I = V.length - 1; N >= 1 && I >= 0 && k[N] !== V[I]; )
            I--;
          for (; N >= 1 && I >= 0; N--, I--)
            if (k[N] !== V[I]) {
              if (N !== 1 || I !== 1)
                do
                  if (N--, I--, I < 0 || k[N] !== V[I]) {
                    var W = `
` + k[N].replace(" at new ", " at ");
                    return o.displayName && W.includes("<anonymous>") && (W = W.replace("<anonymous>", o.displayName)), typeof o == "function" && Ce.set(o, W), W;
                  }
                while (N >= 1 && I >= 0);
              break;
            }
        }
      } finally {
        Ye = !1, Be.current = x, Xr(), Error.prepareStackTrace = T;
      }
      var de = o ? o.displayName || o.name : "", te = de ? Re(de) : "";
      return typeof o == "function" && Ce.set(o, te), te;
    }
    function Zr(o, d, p) {
      return It(o, !1);
    }
    function en(o) {
      var d = o.prototype;
      return !!(d && d.isReactComponent);
    }
    function Te(o, d, p) {
      if (o == null)
        return "";
      if (typeof o == "function")
        return It(o, en(o));
      if (typeof o == "string")
        return Re(o);
      switch (o) {
        case u:
          return Re("Suspense");
        case f:
          return Re("SuspenseList");
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case l:
            return Zr(o.render);
          case m:
            return Te(o.type, d, p);
          case g: {
            var _ = o, T = _._payload, x = _._init;
            try {
              return Te(x(T), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var pe = Object.prototype.hasOwnProperty, jt = {}, Lt = M.ReactDebugCurrentFrame;
    function xe(o) {
      if (o) {
        var d = o._owner, p = Te(o.type, o._source, d ? d.type : null);
        Lt.setExtraStackFrame(p);
      } else
        Lt.setExtraStackFrame(null);
    }
    function tn(o, d, p, _, T) {
      {
        var x = Function.call.bind(pe);
        for (var R in o)
          if (x(o, R)) {
            var k = void 0;
            try {
              if (typeof o[R] != "function") {
                var V = Error((_ || "React class") + ": " + p + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw V.name = "Invariant Violation", V;
              }
              k = o[R](d, R, _, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (N) {
              k = N;
            }
            k && !(k instanceof Error) && (xe(T), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", _ || "React class", p, R, typeof k), xe(null)), k instanceof Error && !(k.message in jt) && (jt[k.message] = !0, xe(T), S("Failed %s type: %s", p, k.message), xe(null));
          }
      }
    }
    var rn = Array.isArray;
    function Ke(o) {
      return rn(o);
    }
    function nn(o) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return p;
      }
    }
    function on(o) {
      try {
        return Vt(o), !1;
      } catch {
        return !0;
      }
    }
    function Vt(o) {
      return "" + o;
    }
    function zt(o) {
      if (on(o))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", nn(o)), Vt(o);
    }
    var me = M.ReactCurrentOwner, an = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ft, $t, Je;
    Je = {};
    function sn(o) {
      if (pe.call(o, "ref")) {
        var d = Object.getOwnPropertyDescriptor(o, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return o.ref !== void 0;
    }
    function cn(o) {
      if (pe.call(o, "key")) {
        var d = Object.getOwnPropertyDescriptor(o, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return o.key !== void 0;
    }
    function ln(o, d) {
      if (typeof o.ref == "string" && me.current && d && me.current.stateNode !== d) {
        var p = A(me.current.type);
        Je[p] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', A(me.current.type), o.ref), Je[p] = !0);
      }
    }
    function un(o, d) {
      {
        var p = function() {
          Ft || (Ft = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(o, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function dn(o, d) {
      {
        var p = function() {
          $t || ($t = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(o, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var fn = function(o, d, p, _, T, x, R) {
      var k = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: o,
        key: d,
        ref: p,
        props: R,
        // Record the component responsible for creating this element.
        _owner: x
      };
      return k._store = {}, Object.defineProperty(k._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(k, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: _
      }), Object.defineProperty(k, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: T
      }), Object.freeze && (Object.freeze(k.props), Object.freeze(k)), k;
    };
    function pn(o, d, p, _, T) {
      {
        var x, R = {}, k = null, V = null;
        p !== void 0 && (zt(p), k = "" + p), cn(d) && (zt(d.key), k = "" + d.key), sn(d) && (V = d.ref, ln(d, T));
        for (x in d)
          pe.call(d, x) && !an.hasOwnProperty(x) && (R[x] = d[x]);
        if (o && o.defaultProps) {
          var N = o.defaultProps;
          for (x in N)
            R[x] === void 0 && (R[x] = N[x]);
        }
        if (k || V) {
          var I = typeof o == "function" ? o.displayName || o.name || "Unknown" : o;
          k && un(R, I), V && dn(R, I);
        }
        return fn(o, k, V, T, _, me.current, R);
      }
    }
    var qe = M.ReactCurrentOwner, Ht = M.ReactDebugCurrentFrame;
    function ue(o) {
      if (o) {
        var d = o._owner, p = Te(o.type, o._source, d ? d.type : null);
        Ht.setExtraStackFrame(p);
      } else
        Ht.setExtraStackFrame(null);
    }
    var Xe;
    Xe = !1;
    function Qe(o) {
      return typeof o == "object" && o !== null && o.$$typeof === t;
    }
    function Wt() {
      {
        if (qe.current) {
          var o = A(qe.current.type);
          if (o)
            return `

Check the render method of \`` + o + "`.";
        }
        return "";
      }
    }
    function mn(o) {
      {
        if (o !== void 0) {
          var d = o.fileName.replace(/^.*[\\\/]/, ""), p = o.lineNumber;
          return `

Check your code at ` + d + ":" + p + ".";
        }
        return "";
      }
    }
    var Ut = {};
    function yn(o) {
      {
        var d = Wt();
        if (!d) {
          var p = typeof o == "string" ? o : o.displayName || o.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function Bt(o, d) {
      {
        if (!o._store || o._store.validated || o.key != null)
          return;
        o._store.validated = !0;
        var p = yn(d);
        if (Ut[p])
          return;
        Ut[p] = !0;
        var _ = "";
        o && o._owner && o._owner !== qe.current && (_ = " It was passed a child from " + A(o._owner.type) + "."), ue(o), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, _), ue(null);
      }
    }
    function Gt(o, d) {
      {
        if (typeof o != "object")
          return;
        if (Ke(o))
          for (var p = 0; p < o.length; p++) {
            var _ = o[p];
            Qe(_) && Bt(_, d);
          }
        else if (Qe(o))
          o._store && (o._store.validated = !0);
        else if (o) {
          var T = O(o);
          if (typeof T == "function" && T !== o.entries)
            for (var x = T.call(o), R; !(R = x.next()).done; )
              Qe(R.value) && Bt(R.value, d);
        }
      }
    }
    function hn(o) {
      {
        var d = o.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === m))
          p = d.propTypes;
        else
          return;
        if (p) {
          var _ = A(d);
          tn(p, o.props, "prop", _, o);
        } else if (d.PropTypes !== void 0 && !Xe) {
          Xe = !0;
          var T = A(d);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", T || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function gn(o) {
      {
        for (var d = Object.keys(o.props), p = 0; p < d.length; p++) {
          var _ = d[p];
          if (_ !== "children" && _ !== "key") {
            ue(o), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", _), ue(null);
            break;
          }
        }
        o.ref !== null && (ue(o), S("Invalid attribute `ref` supplied to `React.Fragment`."), ue(null));
      }
    }
    var Yt = {};
    function Kt(o, d, p, _, T, x) {
      {
        var R = Y(o);
        if (!R) {
          var k = "";
          (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (k += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var V = mn(T);
          V ? k += V : k += Wt();
          var N;
          o === null ? N = "null" : Ke(o) ? N = "array" : o !== void 0 && o.$$typeof === t ? (N = "<" + (A(o.type) || "Unknown") + " />", k = " Did you accidentally export a JSX literal instead of a component?") : N = typeof o, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", N, k);
        }
        var I = pn(o, d, p, T, x);
        if (I == null)
          return I;
        if (R) {
          var W = d.children;
          if (W !== void 0)
            if (_)
              if (Ke(W)) {
                for (var de = 0; de < W.length; de++)
                  Gt(W[de], o);
                Object.freeze && Object.freeze(W);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Gt(W, o);
        }
        if (pe.call(d, "key")) {
          var te = A(o), z = Object.keys(d).filter(function(Sn) {
            return Sn !== "key";
          }), Ze = z.length > 0 ? "{key: someKey, " + z.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Yt[te + Ze]) {
            var wn = z.length > 0 ? "{" + z.join(": ..., ") + ": ...}" : "{}";
            S(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, te, wn, te), Yt[te + Ze] = !0;
          }
        }
        return o === n ? gn(I) : hn(I), I;
      }
    }
    function vn(o, d, p) {
      return Kt(o, d, p, !0);
    }
    function bn(o, d, p) {
      return Kt(o, d, p, !1);
    }
    var _n = bn, En = vn;
    he.Fragment = n, he.jsx = _n, he.jsxs = En;
  }()), he;
}
process.env.NODE_ENV === "production" ? dt.exports = Jn() : dt.exports = qn();
var J = dt.exports;
const Xn = (e) => e.type ? e : Er.fromJSON(e), Qn = (e, t, r) => {
  const n = Xn(e);
  if (!n)
    throw new Error("Invalid geometry provided.");
  return e = n, new xn({
    geometry: e,
    attributes: r,
    symbol: t
  });
}, tt = {
  ID: "highlight_layer",
  LIST_MODE: "hide",
  VISIBLE: !0
}, Qt = (e, t) => {
  e?.map?.add(t);
}, Zt = (e, t) => {
  e?.map?.layers.includes(t) && e.map.remove(t);
}, Zn = (e, t) => e || t, eo = (e, t) => e.map((r) => Qn(r, t));
var Ae = /* @__PURE__ */ ((e) => (e.TwoD = "2D", e.ThreeD = "3D", e))(Ae || {});
const Rr = kn({
  mapView: null,
  setMapView: () => {
  },
  sceneView: null,
  setSceneView: () => {
  },
  highlightGeometries: () => {
  },
  clearHighlights: () => {
  },
  graphicsLayer: null,
  currentHighlights: null,
  currentSymbol: null,
  onMapClick: void 0,
  // Default values for new properties
  mapMode: "2D",
  setMapMode: () => {
  },
  toggleMapMode: () => {
  },
  widgetConfig: void 0,
  setWidgetConfig: () => {
  },
  disableMapClick: !1,
  setDisableMapClick: () => {
  },
  onLocationChange: void 0,
  onWidgetActivation: void 0
}), to = () => Rn(Rr), ka = ({
  children: e,
  onMapClick: t,
  onLocationChange: r,
  onWidgetActivation: n,
  initialMapMode: i = "2D",
  widgetConfig: a
}) => {
  const [c, s] = K(null), [l, u] = K(null), [f, m] = K(null), [g, h] = K(null), [y, v] = K(null), [O, M] = K(i), [S, E] = K(a || {}), [w, b] = K(!1), C = Q(null), D = Q(null), P = Q(null);
  $(() => {
    C.current = f;
  }, [f]), $(() => {
    D.current = c;
  }, [c]), $(() => {
    P.current = l;
  }, [l]), $(() => {
    const A = new Tn({
      id: tt.ID,
      listMode: tt.LIST_MODE,
      visible: tt.VISIBLE
    });
    m(A);
  }, []), $(() => {
    if (f)
      return Qt(c, f), Qt(l, f), () => {
        Zt(c, f), Zt(l, f);
      };
  }, [c, l, f]);
  const U = et((A, B, ee = !1) => {
    const ce = C.current;
    if (!ce)
      return;
    h(A), v(B), ce.removeAll();
    const le = eo(A, B);
    ce.addMany(le), ee && le.length > 0 && Zn(D.current, P.current)?.goTo(le);
  }, []), Y = et(() => {
    const A = C.current;
    A && (A.removeAll(), h(null), v(null));
  }, []), se = et(() => {
    M(
      (A) => A === "2D" ? "3D" : "2D"
      /* TwoD */
    );
  }, []), ke = Cn(() => ({
    mapView: c,
    setMapView: s,
    sceneView: l,
    setSceneView: u,
    highlightGeometries: U,
    clearHighlights: Y,
    graphicsLayer: f,
    currentHighlights: g,
    currentSymbol: y,
    onMapClick: t,
    mapMode: O,
    setMapMode: M,
    toggleMapMode: se,
    widgetConfig: S,
    setWidgetConfig: E,
    disableMapClick: w,
    setDisableMapClick: b,
    onLocationChange: r,
    onWidgetActivation: n
  }), [
    c,
    l,
    U,
    Y,
    f,
    g,
    y,
    t,
    O,
    se,
    S,
    w,
    r,
    n
  ]);
  return /* @__PURE__ */ J.jsx(Rr.Provider, { value: ke, children: e });
}, wt = [0, 55, 248];
function St(e, t) {
  if (typeof document > "u")
    return t;
  const r = getComputedStyle(document.documentElement).getPropertyValue(e).trim();
  if (!r)
    return t;
  const n = r.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (n) {
    const a = n[1].length === 3 ? n[1].split("").map((s) => s + s).join("") : n[1], c = parseInt(a, 16);
    return [c >> 16 & 255, c >> 8 & 255, c & 255];
  }
  const i = r.match(/rgba?\s*\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/i);
  return i ? [Number(i[1]), Number(i[2]), Number(i[3])] : t;
}
function Ra() {
  const [e, t, r] = St("--map-selection", wt);
  return {
    type: "simple-fill",
    color: [e, t, r, 0.12],
    outline: {
      color: [e, t, r, 1],
      width: 2
    }
  };
}
function Ca() {
  const [e, t, r] = St("--map-selection", wt);
  return {
    type: "simple-marker",
    color: [e, t, r, 1],
    size: 10,
    outline: {
      color: [255, 255, 255, 1],
      width: 2
    }
  };
}
function Ta() {
  const [e, t, r] = St("--map-selection", wt);
  return {
    type: "simple-fill",
    color: [0, 0, 0, 0],
    outline: {
      style: "short-dash",
      color: [e, t, r, 0.7],
      width: 1.5
    }
  };
}
var ft = { exports: {} }, rt = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var er;
function ro() {
  if (er)
    return rt;
  er = 1;
  var e = Ve;
  function t(l, u) {
    return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useSyncExternalStore, i = e.useRef, a = e.useEffect, c = e.useMemo, s = e.useDebugValue;
  return rt.useSyncExternalStoreWithSelector = function(l, u, f, m, g) {
    var h = i(null);
    if (h.current === null) {
      var y = { hasValue: !1, value: null };
      h.current = y;
    } else
      y = h.current;
    h = c(
      function() {
        function O(b) {
          if (!M) {
            if (M = !0, S = b, b = m(b), g !== void 0 && y.hasValue) {
              var C = y.value;
              if (g(C, b))
                return E = C;
            }
            return E = b;
          }
          if (C = E, r(S, b))
            return C;
          var D = m(b);
          return g !== void 0 && g(C, D) ? (S = b, C) : (S = b, E = D);
        }
        var M = !1, S, E, w = f === void 0 ? null : f;
        return [
          function() {
            return O(u());
          },
          w === null ? void 0 : function() {
            return O(w());
          }
        ];
      },
      [u, f, m, g]
    );
    var v = n(l, h[0], h[1]);
    return a(
      function() {
        y.hasValue = !0, y.value = v;
      },
      [v]
    ), s(v), v;
  }, rt;
}
var nt = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tr;
function no() {
  return tr || (tr = 1, process.env.NODE_ENV !== "production" && function() {
    function e(l, u) {
      return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = Ve, r = typeof Object.is == "function" ? Object.is : e, n = t.useSyncExternalStore, i = t.useRef, a = t.useEffect, c = t.useMemo, s = t.useDebugValue;
    nt.useSyncExternalStoreWithSelector = function(l, u, f, m, g) {
      var h = i(null);
      if (h.current === null) {
        var y = { hasValue: !1, value: null };
        h.current = y;
      } else
        y = h.current;
      h = c(
        function() {
          function O(b) {
            if (!M) {
              if (M = !0, S = b, b = m(b), g !== void 0 && y.hasValue) {
                var C = y.value;
                if (g(C, b))
                  return E = C;
              }
              return E = b;
            }
            if (C = E, r(S, b))
              return C;
            var D = m(b);
            return g !== void 0 && g(C, D) ? (S = b, C) : (S = b, E = D);
          }
          var M = !1, S, E, w = f === void 0 ? null : f;
          return [
            function() {
              return O(u());
            },
            w === null ? void 0 : function() {
              return O(w());
            }
          ];
        },
        [u, f, m, g]
      );
      var v = n(l, h[0], h[1]);
      return a(
        function() {
          y.hasValue = !0, y.value = v;
        },
        [v]
      ), s(v), v;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), nt;
}
process.env.NODE_ENV === "production" ? ft.exports = ro() : ft.exports = no();
var oo = ft.exports, ot = /* @__PURE__ */ Symbol.for("react-redux-context"), it = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function io() {
  if (!q.createContext)
    return {};
  const e = it[ot] ?? (it[ot] = /* @__PURE__ */ new Map());
  let t = e.get(q.createContext);
  return t || (t = q.createContext(
    null
  ), process.env.NODE_ENV !== "production" && (t.displayName = "ReactRedux"), e.set(q.createContext, t)), t;
}
var oe = /* @__PURE__ */ io();
function kt(e = oe) {
  return function() {
    const r = q.useContext(e);
    if (process.env.NODE_ENV !== "production" && !r)
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    return r;
  };
}
var Cr = /* @__PURE__ */ kt();
function Tr(e = oe) {
  const t = e === oe ? Cr : (
    // @ts-ignore
    kt(e)
  ), r = () => {
    const { store: n } = t();
    return n;
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var ao = /* @__PURE__ */ Tr();
function so(e = oe) {
  const t = e === oe ? ao : Tr(e), r = () => t().dispatch;
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var co = /* @__PURE__ */ so(), lo = (e, t) => e === t;
function uo(e = oe) {
  const t = e === oe ? Cr : kt(e), r = (n, i = {}) => {
    const { equalityFn: a = lo } = typeof i == "function" ? { equalityFn: i } : i;
    if (process.env.NODE_ENV !== "production") {
      if (!n)
        throw new Error("You must pass a selector to useSelector");
      if (typeof n != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof a != "function")
        throw new Error(
          "You must pass a function as an equality function to useSelector"
        );
    }
    const c = t(), { store: s, subscription: l, getServerState: u } = c, f = q.useRef(!0), m = q.useCallback(
      {
        [n.name](h) {
          const y = n(h);
          if (process.env.NODE_ENV !== "production") {
            const { devModeChecks: v = {} } = typeof i == "function" ? {} : i, { identityFunctionCheck: O, stabilityCheck: M } = c, {
              identityFunctionCheck: S,
              stabilityCheck: E
            } = {
              stabilityCheck: M,
              identityFunctionCheck: O,
              ...v
            };
            if (E === "always" || E === "once" && f.current) {
              const w = n(h);
              if (!a(y, w)) {
                let b;
                try {
                  throw new Error();
                } catch (C) {
                  ({ stack: b } = C);
                }
                console.warn(
                  "Selector " + (n.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`,
                  {
                    state: h,
                    selected: y,
                    selected2: w,
                    stack: b
                  }
                );
              }
            }
            if ((S === "always" || S === "once" && f.current) && y === h) {
              let w;
              try {
                throw new Error();
              } catch (b) {
                ({ stack: w } = b);
              }
              console.warn(
                "Selector " + (n.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`,
                { stack: w }
              );
            }
            f.current && (f.current = !1);
          }
          return y;
        }
      }[n.name],
      [n]
    ), g = oo.useSyncExternalStoreWithSelector(
      l.addNestedSub,
      s.getState,
      u || s.getState,
      m,
      a
    );
    return q.useDebugValue(g), g;
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var pt = /* @__PURE__ */ uo(), at = () => Math.random().toString(36).substring(7).split("").join(".");
`${at()}`, `${at()}`;
function fo(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function po(e) {
  return fo(e) && "type" in e && typeof e.type == "string";
}
var xr = Symbol.for("immer-nothing"), rr = Symbol.for("immer-draftable"), H = Symbol.for("immer-state"), mo = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function F(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const r = mo[e], n = typeof r == "function" ? r.apply(null, t) : r;
    throw new Error(`[Immer] ${n}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var be = Object.getPrototypeOf;
function ie(e) {
  return !!e && !!e[H];
}
function G(e) {
  return e ? Or(e) || Array.isArray(e) || !!e[rr] || !!e.constructor?.[rr] || Se(e) || $e(e) : !1;
}
var yo = Object.prototype.constructor.toString(), nr = /* @__PURE__ */ new WeakMap();
function Or(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = Object.getPrototypeOf(e);
  if (t === null || t === Object.prototype)
    return !0;
  const r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  if (r === Object)
    return !0;
  if (typeof r != "function")
    return !1;
  let n = nr.get(r);
  return n === void 0 && (n = Function.toString.call(r), nr.set(r, n)), n === yo;
}
function Ie(e, t, r = !0) {
  Fe(e) === 0 ? (r ? Reflect.ownKeys(e) : Object.keys(e)).forEach((i) => {
    t(i, e[i], e);
  }) : e.forEach((n, i) => t(i, n, e));
}
function Fe(e) {
  const t = e[H];
  return t ? t.type_ : Array.isArray(e) ? 1 : Se(e) ? 2 : $e(e) ? 3 : 0;
}
function mt(e, t) {
  return Fe(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Dr(e, t, r) {
  const n = Fe(e);
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
}
function ho(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Se(e) {
  return e instanceof Map;
}
function $e(e) {
  return e instanceof Set;
}
function ne(e) {
  return e.copy_ || e.base_;
}
function yt(e, t) {
  if (Se(e))
    return new Map(e);
  if ($e(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const r = Or(e);
  if (t === !0 || t === "class_only" && !r) {
    const n = Object.getOwnPropertyDescriptors(e);
    delete n[H];
    let i = Reflect.ownKeys(n);
    for (let a = 0; a < i.length; a++) {
      const c = i[a], s = n[c];
      s.writable === !1 && (s.writable = !0, s.configurable = !0), (s.get || s.set) && (n[c] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: s.enumerable,
        value: e[c]
      });
    }
    return Object.create(be(e), n);
  } else {
    const n = be(e);
    if (n !== null && r)
      return { ...e };
    const i = Object.create(n);
    return Object.assign(i, e);
  }
}
function Rt(e, t = !1) {
  return He(e) || ie(e) || !G(e) || (Fe(e) > 1 && Object.defineProperties(e, {
    set: Oe,
    add: Oe,
    clear: Oe,
    delete: Oe
  }), Object.freeze(e), t && Object.values(e).forEach((r) => Rt(r, !0))), e;
}
function go() {
  F(2);
}
var Oe = {
  value: go
};
function He(e) {
  return e === null || typeof e != "object" ? !0 : Object.isFrozen(e);
}
var vo = {};
function ae(e) {
  const t = vo[e];
  return t || F(0, e), t;
}
var _e;
function Mr() {
  return _e;
}
function bo(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function or(e, t) {
  t && (ae("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function ht(e) {
  gt(e), e.drafts_.forEach(_o), e.drafts_ = null;
}
function gt(e) {
  e === _e && (_e = e.parent_);
}
function ir(e) {
  return _e = bo(_e, e);
}
function _o(e) {
  const t = e[H];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function ar(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const r = t.drafts_[0];
  return e !== void 0 && e !== r ? (r[H].modified_ && (ht(t), F(4)), G(e) && (e = je(t, e), t.parent_ || Le(t, e)), t.patches_ && ae("Patches").generateReplacementPatches_(
    r[H].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = je(t, r, []), ht(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== xr ? e : void 0;
}
function je(e, t, r) {
  if (He(t))
    return t;
  const n = e.immer_.shouldUseStrictIteration(), i = t[H];
  if (!i)
    return Ie(
      t,
      (a, c) => sr(e, i, t, a, c, r),
      n
    ), t;
  if (i.scope_ !== e)
    return t;
  if (!i.modified_)
    return Le(e, i.base_, !0), i.base_;
  if (!i.finalized_) {
    i.finalized_ = !0, i.scope_.unfinalizedDrafts_--;
    const a = i.copy_;
    let c = a, s = !1;
    i.type_ === 3 && (c = new Set(a), a.clear(), s = !0), Ie(
      c,
      (l, u) => sr(
        e,
        i,
        a,
        l,
        u,
        r,
        s
      ),
      n
    ), Le(e, a, !1), r && e.patches_ && ae("Patches").generatePatches_(
      i,
      r,
      e.patches_,
      e.inversePatches_
    );
  }
  return i.copy_;
}
function sr(e, t, r, n, i, a, c) {
  if (i == null || typeof i != "object" && !c)
    return;
  const s = He(i);
  if (!(s && !c)) {
    if (process.env.NODE_ENV !== "production" && i === r && F(5), ie(i)) {
      const l = a && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
      !mt(t.assigned_, n) ? a.concat(n) : void 0, u = je(e, i, l);
      if (Dr(r, n, u), ie(u))
        e.canAutoFreeze_ = !1;
      else
        return;
    } else
      c && r.add(i);
    if (G(i) && !s) {
      if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1 || t && t.base_ && t.base_[n] === i && s)
        return;
      je(e, i), (!t || !t.scope_.parent_) && typeof n != "symbol" && (Se(r) ? r.has(n) : Object.prototype.propertyIsEnumerable.call(r, n)) && Le(e, i);
    }
  }
}
function Le(e, t, r = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Rt(t, r);
}
function Eo(e, t) {
  const r = Array.isArray(e), n = {
    type_: r ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : Mr(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let i = n, a = Ct;
  r && (i = [n], a = Ee);
  const { revoke: c, proxy: s } = Proxy.revocable(i, a);
  return n.draft_ = s, n.revoke_ = c, s;
}
var Ct = {
  get(e, t) {
    if (t === H)
      return e;
    const r = ne(e);
    if (!mt(r, t))
      return wo(e, r, t);
    const n = r[t];
    return e.finalized_ || !G(n) ? n : n === st(e.base_, t) ? (ct(e), e.copy_[t] = bt(n, e)) : n;
  },
  has(e, t) {
    return t in ne(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(ne(e));
  },
  set(e, t, r) {
    const n = Pr(ne(e), t);
    if (n?.set)
      return n.set.call(e.draft_, r), !0;
    if (!e.modified_) {
      const i = st(ne(e), t), a = i?.[H];
      if (a && a.base_ === r)
        return e.copy_[t] = r, e.assigned_[t] = !1, !0;
      if (ho(r, i) && (r !== void 0 || mt(e.base_, t)))
        return !0;
      ct(e), vt(e);
    }
    return e.copy_[t] === r && // special case: handle new props with value 'undefined'
    (r !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(r) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = r, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return st(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, ct(e), vt(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const r = ne(e), n = Reflect.getOwnPropertyDescriptor(r, t);
    return n && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: n.enumerable,
      value: r[t]
    };
  },
  defineProperty() {
    F(11);
  },
  getPrototypeOf(e) {
    return be(e.base_);
  },
  setPrototypeOf() {
    F(12);
  }
}, Ee = {};
Ie(Ct, (e, t) => {
  Ee[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
Ee.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && F(13), Ee.set.call(this, e, t, void 0);
};
Ee.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && F(14), Ct.set.call(this, e[0], t, r, e[0]);
};
function st(e, t) {
  const r = e[H];
  return (r ? ne(r) : e)[t];
}
function wo(e, t, r) {
  const n = Pr(t, r);
  return n ? "value" in n ? n.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    n.get?.call(e.draft_)
  ) : void 0;
}
function Pr(e, t) {
  if (!(t in e))
    return;
  let r = be(e);
  for (; r; ) {
    const n = Object.getOwnPropertyDescriptor(r, t);
    if (n)
      return n;
    r = be(r);
  }
}
function vt(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && vt(e.parent_));
}
function ct(e) {
  e.copy_ || (e.copy_ = yt(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var So = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !0, this.produce = (t, r, n) => {
      if (typeof t == "function" && typeof r != "function") {
        const a = r;
        r = t;
        const c = this;
        return function(l = a, ...u) {
          return c.produce(l, (f) => r.call(this, f, ...u));
        };
      }
      typeof r != "function" && F(6), n !== void 0 && typeof n != "function" && F(7);
      let i;
      if (G(t)) {
        const a = ir(this), c = bt(t, void 0);
        let s = !0;
        try {
          i = r(c), s = !1;
        } finally {
          s ? ht(a) : gt(a);
        }
        return or(a, n), ar(i, a);
      } else if (!t || typeof t != "object") {
        if (i = r(t), i === void 0 && (i = t), i === xr && (i = void 0), this.autoFreeze_ && Rt(i, !0), n) {
          const a = [], c = [];
          ae("Patches").generateReplacementPatches_(t, i, a, c), n(a, c);
        }
        return i;
      } else
        F(1, t);
    }, this.produceWithPatches = (t, r) => {
      if (typeof t == "function")
        return (c, ...s) => this.produceWithPatches(c, (l) => t(l, ...s));
      let n, i;
      return [this.produce(t, r, (c, s) => {
        n = c, i = s;
      }), n, i];
    }, typeof e?.autoFreeze == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof e?.useStrictShallowCopy == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy), typeof e?.useStrictIteration == "boolean" && this.setUseStrictIteration(e.useStrictIteration);
  }
  createDraft(e) {
    G(e) || F(8), ie(e) && (e = Nr(e));
    const t = ir(this), r = bt(e, void 0);
    return r[H].isManual_ = !0, gt(t), r;
  }
  finishDraft(e, t) {
    const r = e && e[H];
    (!r || !r.isManual_) && F(9);
    const { scope_: n } = r;
    return or(n, t), ar(void 0, n);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(e) {
    this.useStrictIteration_ = e;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(e, t) {
    let r;
    for (r = t.length - 1; r >= 0; r--) {
      const i = t[r];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    r > -1 && (t = t.slice(r + 1));
    const n = ae("Patches").applyPatches_;
    return ie(e) ? n(e, t) : this.produce(
      e,
      (i) => n(i, t)
    );
  }
};
function bt(e, t) {
  const r = Se(e) ? ae("MapSet").proxyMap_(e, t) : $e(e) ? ae("MapSet").proxySet_(e, t) : Eo(e, t);
  return (t ? t.scope_ : Mr()).drafts_.push(r), r;
}
function Nr(e) {
  return ie(e) || F(10, e), Ar(e);
}
function Ar(e) {
  if (!G(e) || He(e))
    return e;
  const t = e[H];
  let r, n = !0;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, r = yt(e, t.scope_.immer_.useStrictShallowCopy_), n = t.scope_.immer_.shouldUseStrictIteration();
  } else
    r = yt(e, !0);
  return Ie(
    r,
    (i, a) => {
      Dr(r, i, Ar(a));
    },
    n
  ), t && (t.finalized_ = !1), r;
}
var _t = new So(), Ir = _t.produce, ko = /* @__PURE__ */ _t.setUseStrictIteration.bind(
  _t
), Ro = (e, t, r) => {
  if (t.length === 1 && t[0] === r) {
    let n = !1;
    try {
      const i = {};
      e(i) === i && (n = !0);
    } catch {
    }
    if (n) {
      let i;
      try {
        throw new Error();
      } catch (a) {
        ({ stack: i } = a);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: i }
      );
    }
  }
}, Co = (e, t, r) => {
  const { memoize: n, memoizeOptions: i } = t, { inputSelectorResults: a, inputSelectorResultsCopy: c } = e, s = n(() => ({}), ...i);
  if (!(s.apply(null, a) === s.apply(null, c))) {
    let u;
    try {
      throw new Error();
    } catch (f) {
      ({ stack: u } = f);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: r,
        firstInputs: a,
        secondInputs: c,
        stack: u
      }
    );
  }
}, To = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function xo(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function Oo(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function Do(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((r) => typeof r == "function")) {
    const r = e.map(
      (n) => typeof n == "function" ? `function ${n.name || "unnamed"}()` : typeof n
    ).join(", ");
    throw new TypeError(`${t}[${r}]`);
  }
}
var cr = (e) => Array.isArray(e) ? e : [e];
function Mo(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return Do(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function lr(e, t) {
  const r = [], { length: n } = e;
  for (let i = 0; i < n; i++)
    r.push(e[i].apply(null, t));
  return r;
}
var Po = (e, t) => {
  const { identityFunctionCheck: r, inputStabilityCheck: n } = {
    ...To,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: Ro
    },
    inputStabilityCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: Co
    }
  };
}, No = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, Ao = typeof WeakRef < "u" ? WeakRef : No, Io = 0, ur = 1;
function De() {
  return {
    s: Io,
    v: void 0,
    o: null,
    p: null
  };
}
function jr(e, t = {}) {
  let r = De();
  const { resultEqualityCheck: n } = t;
  let i, a = 0;
  function c() {
    let s = r;
    const { length: l } = arguments;
    for (let m = 0, g = l; m < g; m++) {
      const h = arguments[m];
      if (typeof h == "function" || typeof h == "object" && h !== null) {
        let y = s.o;
        y === null && (s.o = y = /* @__PURE__ */ new WeakMap());
        const v = y.get(h);
        v === void 0 ? (s = De(), y.set(h, s)) : s = v;
      } else {
        let y = s.p;
        y === null && (s.p = y = /* @__PURE__ */ new Map());
        const v = y.get(h);
        v === void 0 ? (s = De(), y.set(h, s)) : s = v;
      }
    }
    const u = s;
    let f;
    if (s.s === ur)
      f = s.v;
    else if (f = e.apply(null, arguments), a++, n) {
      const m = i?.deref?.() ?? i;
      m != null && n(m, f) && (f = m, a !== 0 && a--), i = typeof f == "object" && f !== null || typeof f == "function" ? new Ao(f) : f;
    }
    return u.s = ur, u.v = f, f;
  }
  return c.clearCache = () => {
    r = De(), c.resetResultsCount();
  }, c.resultsCount = () => a, c.resetResultsCount = () => {
    a = 0;
  }, c;
}
function jo(e, ...t) {
  const r = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, n = (...i) => {
    let a = 0, c = 0, s, l = {}, u = i.pop();
    typeof u == "object" && (l = u, u = i.pop()), xo(
      u,
      `createSelector expects an output function after the inputs, but received: [${typeof u}]`
    );
    const f = {
      ...r,
      ...l
    }, {
      memoize: m,
      memoizeOptions: g = [],
      argsMemoize: h = jr,
      argsMemoizeOptions: y = [],
      devModeChecks: v = {}
    } = f, O = cr(g), M = cr(y), S = Mo(i), E = m(function() {
      return a++, u.apply(
        null,
        arguments
      );
    }, ...O);
    let w = !0;
    const b = h(function() {
      c++;
      const D = lr(
        S,
        arguments
      );
      if (s = E.apply(null, D), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: P, inputStabilityCheck: U } = Po(w, v);
        if (P.shouldRun && P.run(
          u,
          D,
          s
        ), U.shouldRun) {
          const Y = lr(
            S,
            arguments
          );
          U.run(
            { inputSelectorResults: D, inputSelectorResultsCopy: Y },
            { memoize: m, memoizeOptions: O },
            arguments
          );
        }
        w && (w = !1);
      }
      return s;
    }, ...M);
    return Object.assign(b, {
      resultFunc: u,
      memoizedResultFunc: E,
      dependencies: S,
      dependencyRecomputations: () => c,
      resetDependencyRecomputations: () => {
        c = 0;
      },
      lastResult: () => s,
      recomputations: () => a,
      resetRecomputations: () => {
        a = 0;
      },
      memoize: m,
      argsMemoize: h
    });
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var Tt = /* @__PURE__ */ jo(jr), Lo = Object.assign(
  (e, t = Tt) => {
    Oo(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const r = Object.keys(e), n = r.map(
      (a) => e[a]
    );
    return t(
      n,
      (...a) => a.reduce((c, s, l) => (c[r[l]] = s, c), {})
    );
  },
  { withTypes: () => Lo }
);
function dr(e, t) {
  function r(...n) {
    if (t) {
      let i = t(...n);
      if (!i)
        throw new Error(process.env.NODE_ENV === "production" ? L(0) : "prepareAction did not return an object");
      return {
        type: e,
        payload: i.payload,
        ..."meta" in i && {
          meta: i.meta
        },
        ..."error" in i && {
          error: i.error
        }
      };
    }
    return {
      type: e,
      payload: n[0]
    };
  }
  return r.toString = () => `${e}`, r.type = e, r.match = (n) => po(n) && n.type === e, r;
}
function fr(e) {
  return G(e) ? Ir(e, () => {
  }) : e;
}
function Me(e, t, r) {
  return e.has(t) ? e.get(t) : e.set(t, r(t)).get(t);
}
function Lr(e) {
  const t = {}, r = [];
  let n;
  const i = {
    addCase(a, c) {
      if (process.env.NODE_ENV !== "production") {
        if (r.length > 0)
          throw new Error(process.env.NODE_ENV === "production" ? L(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (n)
          throw new Error(process.env.NODE_ENV === "production" ? L(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const s = typeof a == "string" ? a : a.type;
      if (!s)
        throw new Error(process.env.NODE_ENV === "production" ? L(28) : "`builder.addCase` cannot be called with an empty action type");
      if (s in t)
        throw new Error(process.env.NODE_ENV === "production" ? L(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${s}'`);
      return t[s] = c, i;
    },
    addAsyncThunk(a, c) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? L(43) : "`builder.addAsyncThunk` should only be called before calling `builder.addDefaultCase`");
      return c.pending && (t[a.pending.type] = c.pending), c.rejected && (t[a.rejected.type] = c.rejected), c.fulfilled && (t[a.fulfilled.type] = c.fulfilled), c.settled && r.push({
        matcher: a.settled,
        reducer: c.settled
      }), i;
    },
    addMatcher(a, c) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? L(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return r.push({
        matcher: a,
        reducer: c
      }), i;
    },
    addDefaultCase(a) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? L(31) : "`builder.addDefaultCase` can only be called once");
      return n = a, i;
    }
  };
  return e(i), [t, r, n];
}
ko(!1);
function Vo(e) {
  return typeof e == "function";
}
function zo(e, t) {
  if (process.env.NODE_ENV !== "production" && typeof t == "object")
    throw new Error(process.env.NODE_ENV === "production" ? L(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [r, n, i] = Lr(t), a;
  if (Vo(e))
    a = () => fr(e());
  else {
    const s = fr(e);
    a = () => s;
  }
  function c(s = a(), l) {
    let u = [r[l.type], ...n.filter(({
      matcher: f
    }) => f(l)).map(({
      reducer: f
    }) => f)];
    return u.filter((f) => !!f).length === 0 && (u = [i]), u.reduce((f, m) => {
      if (m)
        if (ie(f)) {
          const h = m(f, l);
          return h === void 0 ? f : h;
        } else {
          if (G(f))
            return Ir(f, (g) => m(g, l));
          {
            const g = m(f, l);
            if (g === void 0) {
              if (f === null)
                return f;
              throw Error("A case reducer on a non-draftable value must not return undefined");
            }
            return g;
          }
        }
      return f;
    }, s);
  }
  return c.getInitialState = a, c;
}
var Fo = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function $o(e, t) {
  return `${e}/${t}`;
}
function Ho({
  creators: e
} = {}) {
  const t = e?.asyncThunk?.[Fo];
  return function(n) {
    const {
      name: i,
      reducerPath: a = i
    } = n;
    if (!i)
      throw new Error(process.env.NODE_ENV === "production" ? L(11) : "`name` is a required option for createSlice");
    typeof process < "u" && process.env.NODE_ENV === "development" && n.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const c = (typeof n.reducers == "function" ? n.reducers(Bo()) : n.reducers) || {}, s = Object.keys(c), l = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, u = {
      addCase(E, w) {
        const b = typeof E == "string" ? E : E.type;
        if (!b)
          throw new Error(process.env.NODE_ENV === "production" ? L(12) : "`context.addCase` cannot be called with an empty action type");
        if (b in l.sliceCaseReducersByType)
          throw new Error(process.env.NODE_ENV === "production" ? L(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + b);
        return l.sliceCaseReducersByType[b] = w, u;
      },
      addMatcher(E, w) {
        return l.sliceMatchers.push({
          matcher: E,
          reducer: w
        }), u;
      },
      exposeAction(E, w) {
        return l.actionCreators[E] = w, u;
      },
      exposeCaseReducer(E, w) {
        return l.sliceCaseReducersByName[E] = w, u;
      }
    };
    s.forEach((E) => {
      const w = c[E], b = {
        reducerName: E,
        type: $o(i, E),
        createNotation: typeof n.reducers == "function"
      };
      Yo(w) ? Jo(b, w, u, t) : Go(b, w, u);
    });
    function f() {
      if (process.env.NODE_ENV !== "production" && typeof n.extraReducers == "object")
        throw new Error(process.env.NODE_ENV === "production" ? L(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [E = {}, w = [], b = void 0] = typeof n.extraReducers == "function" ? Lr(n.extraReducers) : [n.extraReducers], C = {
        ...E,
        ...l.sliceCaseReducersByType
      };
      return zo(n.initialState, (D) => {
        for (let P in C)
          D.addCase(P, C[P]);
        for (let P of l.sliceMatchers)
          D.addMatcher(P.matcher, P.reducer);
        for (let P of w)
          D.addMatcher(P.matcher, P.reducer);
        b && D.addDefaultCase(b);
      });
    }
    const m = (E) => E, g = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new WeakMap();
    let y;
    function v(E, w) {
      return y || (y = f()), y(E, w);
    }
    function O() {
      return y || (y = f()), y.getInitialState();
    }
    function M(E, w = !1) {
      function b(D) {
        let P = D[E];
        if (typeof P > "u") {
          if (w)
            P = Me(h, b, O);
          else if (process.env.NODE_ENV !== "production")
            throw new Error(process.env.NODE_ENV === "production" ? L(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return P;
      }
      function C(D = m) {
        const P = Me(g, w, () => /* @__PURE__ */ new WeakMap());
        return Me(P, D, () => {
          const U = {};
          for (const [Y, se] of Object.entries(n.selectors ?? {}))
            U[Y] = Wo(se, D, () => Me(h, D, O), w);
          return U;
        });
      }
      return {
        reducerPath: E,
        getSelectors: C,
        get selectors() {
          return C(b);
        },
        selectSlice: b
      };
    }
    const S = {
      name: i,
      reducer: v,
      actions: l.actionCreators,
      caseReducers: l.sliceCaseReducersByName,
      getInitialState: O,
      ...M(a),
      injectInto(E, {
        reducerPath: w,
        ...b
      } = {}) {
        const C = w ?? a;
        return E.inject({
          reducerPath: C,
          reducer: v
        }, b), {
          ...S,
          ...M(C, !0)
        };
      }
    };
    return S;
  };
}
function Wo(e, t, r, n) {
  function i(a, ...c) {
    let s = t(a);
    if (typeof s > "u") {
      if (n)
        s = r();
      else if (process.env.NODE_ENV !== "production")
        throw new Error(process.env.NODE_ENV === "production" ? L(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return e(s, ...c);
  }
  return i.unwrapped = e, i;
}
var Uo = /* @__PURE__ */ Ho();
function Bo() {
  function e(t, r) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...r
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...r) {
          return t(...r);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, r) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: r
      };
    },
    asyncThunk: e
  };
}
function Go({
  type: e,
  reducerName: t,
  createNotation: r
}, n, i) {
  let a, c;
  if ("reducer" in n) {
    if (r && !Ko(n))
      throw new Error(process.env.NODE_ENV === "production" ? L(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    a = n.reducer, c = n.prepare;
  } else
    a = n;
  i.addCase(e, a).exposeCaseReducer(t, a).exposeAction(t, c ? dr(e, c) : dr(e));
}
function Yo(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function Ko(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function Jo({
  type: e,
  reducerName: t
}, r, n, i) {
  if (!i)
    throw new Error(process.env.NODE_ENV === "production" ? L(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: a,
    fulfilled: c,
    pending: s,
    rejected: l,
    settled: u,
    options: f
  } = r, m = i(e, a, f);
  n.exposeAction(t, m), c && n.addCase(m.fulfilled, c), s && n.addCase(m.pending, s), l && n.addCase(m.rejected, l), u && n.addMatcher(m.settled, u), n.exposeCaseReducer(t, {
    fulfilled: c || Pe,
    pending: s || Pe,
    rejected: l || Pe,
    settled: u || Pe
  });
}
function Pe() {
}
function L(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
const qo = {
  mode: "2d",
  extent: void 0,
  zoom: void 0,
  scale: void 0,
  selectedPoint: null,
  locationHistory: [],
  highlightGeometries: null,
  disableMapClick: !1,
  selectedLocation: null
}, Vr = Uo({
  name: "map",
  initialState: qo,
  reducers: {
    setMapMode(e, t) {
      e.mode = t.payload;
    },
    toggleMapMode(e) {
      e.mode = e.mode === "2d" ? "3d" : "2d";
    },
    setExtent(e, t) {
      const r = Nr(e).extent;
      (!r || Math.abs(r.xmin - (t.payload.extent?.xmin || 0)) > 1 || Math.abs(r.ymin - (t.payload.extent?.ymin || 0)) > 1 || Math.abs(r.xmax - (t.payload.extent?.xmax || 0)) > 1 || Math.abs(r.ymax - (t.payload.extent?.ymax || 0)) > 1) && (e.extent = t.payload.extent, e.zoom = t.payload.zoom, e.scale = t.payload.scale);
    },
    setSelectedPoint(e, t) {
      e.selectedPoint = t.payload;
    },
    addToLocationHistory(e, t) {
      t.payload.selected ? e.locationHistory.forEach((r) => r.selected = !1) : e.locationHistory.length === 0 && (t.payload.selected = !0), t.payload.id || (t.payload.id = crypto.randomUUID()), e.locationHistory.unshift(t.payload), e.locationHistory.length > 10 && e.locationHistory.pop(), e.selectedLocation = t.payload.selected ? t.payload : e.selectedLocation;
    },
    setLocationHistorySelected(e, t) {
      e.locationHistory.forEach((r) => {
        r.selected = r.id === t.payload, r.selected && (e.selectedLocation = r);
      });
    },
    setSelectedLocation(e, t) {
      if (t.payload) {
        e.locationHistory.forEach((n) => n.selected = !1);
        const r = e.locationHistory.find(
          (n) => n.x === t.payload.x && n.y === t.payload.y
        );
        r ? r.selected = !0 : (t.payload.id || (t.payload.id = crypto.randomUUID()), t.payload.selected = !0, e.locationHistory.unshift(t.payload), e.locationHistory.length > 10 && e.locationHistory.pop());
      }
      e.selectedLocation = t.payload;
    },
    setHighlightGeometries(e, t) {
      e.highlightGeometries = t.payload;
    },
    setDisableMapClick(e, t) {
      e.disableMapClick = t.payload;
    }
  }
}), {
  setMapMode: xa,
  toggleMapMode: Oa,
  setExtent: Da,
  setSelectedPoint: Ma,
  addToLocationHistory: Pa,
  setLocationHistorySelected: Na,
  setSelectedLocation: Xo,
  setHighlightGeometries: Aa,
  setDisableMapClick: Qo
} = Vr.actions, Ia = (e) => e.map.locationHistory, zr = (e) => e.map.disableMapClick, Zo = (e) => e.map.selectedLocation;
Tt(
  (e) => e.map.highlightGeometries,
  (e) => e ? {
    geometries: e.geometries?.map((r) => Er.fromJSON(r))?.filter((r) => r !== void 0),
    symbol: e.symbol,
    zoomTo: e.zoomTo
  } : null
);
Tt(
  (e) => e.map.locationHistory,
  (e) => {
    const t = e?.filter((r) => r.selected);
    return t && t.length === 1 ? t[0] : null;
  }
);
Vr.reducer;
const Fr = () => {
  const e = co(), t = pt(zr), r = pt(Zo);
  return {
    disableMapClick: t,
    selectedLocation: r,
    setDisableMapClick: (n) => e(Qo(n)),
    setSelectedLocation: (n) => e(Xo(n))
  };
}, ja = () => pt(zr);
new jn({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapAdmin/MapServer",
  title: "Administrative enheter",
  visible: !1
});
const pr = new kr({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapGeoEiendom/MapServer/15",
  title: "Eiendomsgrenser",
  visible: !0,
  id: "Eiendomsgrenser"
}), lt = new kr({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapGeoEiendom/MapServer/7",
  title: "Eiendommer",
  visible: !0,
  id: "Eiendommer"
});
new zn({
  layers: [
    new Vn({
      url: "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_EUREF89/GeocacheTerreng/ImageServer"
    })
  ],
  navigationConstraint: { type: "stay-above" }
});
new Ln({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geoscene/GeosceneBygning2/SceneServer",
  minScale: 2e4,
  title: "Bygninger",
  popupEnabled: !1
});
const ei = new X({
  baseLayers: [
    new ve({
      url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasisTerreng_UTM32/VectorTileServer"
    })
  ],
  id: "basis_terreng",
  thumbnailUrl: "images/basis terreng.png"
}), $r = new X({
  baseLayers: [
    new ve({
      url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheGraatoneTerreng_UTM32/VectorTileServer"
    })
  ],
  id: "graatone_terreng",
  thumbnailUrl: "images/gråtone terreng.png"
}), ti = new X({
  baseLayers: [
    new ve({
      url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheKanvasMork_UTM32/VectorTileServer"
    })
  ],
  id: "mork",
  thumbnailUrl: "images/kanvas mørk.png"
}), ri = new X({
  baseLayers: [
    new In({
      url: (
        // 'https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM32_EUREF89/GeocacheBilder/MapServer'
        "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_EUREF89/GeocacheBilder/MapServer"
      )
    })
  ],
  id: "bilder",
  thumbnailUrl: "images/bilder.png"
}), ge = new Fn({
  basemaps: [ei, $r, ri, ti]
}), ni = new Sr({
  url: "https://services.geodataonline.no/arcgis/rest/services/ProxyServices/Adresse/GeocodeServer",
  singleLineFieldName: "SingleLine",
  name: "Adressesøk",
  placeholder: "",
  // i18next.t("search.placeholder", {ns: "map"}),
  maxResults: 3,
  maxSuggestions: 6,
  suggestionsEnabled: !0,
  minSuggestCharacters: 2,
  zoomScale: 5e3,
  popupEnabled: !1
}), oi = new Sr({
  url: "https://services.geodataonline.no/arcgis/rest/services/ProxyServices/Adresse__filter_kilde-eiendom/GeocodeServer",
  singleLineFieldName: "SingleLine",
  name: "Eiendomssøk",
  placeholder: "",
  // i18next.t("search.placeholder", {ns: "map"}),
  maxResults: 3,
  maxSuggestions: 6,
  suggestionsEnabled: !0,
  minSuggestCharacters: 2,
  zoomScale: 5e3,
  popupEnabled: !1
});
function ii(e) {
  const t = ge.basemaps.at(0);
  t && (t.title = e.t("basemaps.basis", { ns: "map" }));
  const r = ge.basemaps.at(1);
  r && (r.title = e.t("basemaps.graatone", { ns: "map" }));
  const n = ge.basemaps.at(2);
  n && (n.title = e.t("basemaps.bilder", { ns: "map" }));
  const i = ge.basemaps.at(3);
  i && (i.title = e.t("basemaps.mork", { ns: "map" }));
}
const re = we("MapInit"), ai = ({
  containerRef: e,
  mapMode: t,
  webMapId: r,
  webSceneId: n,
  basemapConfig: i,
  disablePopup: a,
  initialView: c,
  onMapViewCreated: s,
  onSceneViewCreated: l
}) => {
  const u = Q(null), f = Q(c);
  return $(() => {
    if (!e.current)
      return;
    let m = null, g = !1;
    return (async () => {
      let y;
      if (t === Ae.TwoD) {
        if (r)
          re.debug("Initializing 2D MapView with webMap", r), y = new Mn({
            portalItem: {
              id: r
            }
          });
        else {
          re.debug("Initializing 2D MapView with basemap config");
          const O = i ? new X(i) : new X({
            baseLayers: [
              new ve({
                url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasisTerreng_UTM32/VectorTileServer"
              })
            ],
            id: "basis_terreng",
            title: "Basis Terreng"
          });
          y = new Jt({
            basemap: O
          });
        }
        u.current = y, re.debug("Map instance created for 2D view");
        const v = f.current;
        m = new Nn({
          container: e.current,
          map: y,
          popupEnabled: !a,
          ...v && {
            center: new wr({ x: v.x, y: v.y, spatialReference: { wkid: v.wkid } }),
            zoom: v.zoom
          }
        }), m.when(() => {
          !g && s && (s(m), m?.map?.add(pr), lt.outFields = ["id", "objectid", "gids"], m?.map?.add(lt));
        }).catch((O) => {
          re.error("MapView failed to load:", O);
        });
      } else {
        if (n)
          re.debug("Initializing 3D SceneView with webScene", n), y = new Pn({
            portalItem: {
              id: n
            }
          });
        else {
          re.debug("Initializing 3D SceneView with basemap config");
          const v = i ? new X(i) : new X({
            baseLayers: [
              new ve({
                url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasisTerreng_UTM32/VectorTileServer"
              })
            ],
            id: "basis_terreng",
            title: "Basis Terreng"
          });
          y = new Jt({
            basemap: v
          });
        }
        u.current = y, m = new An({
          container: e.current,
          map: y,
          popupEnabled: !a,
          center: [10.7522, 59.9139],
          zoom: 10
        }), m.when(() => {
          !g && l && l(m);
        }).catch((v) => {
          re.error("SceneView failed to load:", v);
        });
      }
    })(), () => {
      g = !0;
      const y = u.current;
      if (y) {
        try {
          y.layers?.remove(pr), y.layers?.remove(lt);
        } catch {
        }
        try {
          y.basemap = null;
        } catch {
        }
      }
      u.current = null, m && !m.destroyed && m.destroy();
    };
  }, [t, e, r, n, i, s, l]), { mapRef: u };
};
function si(e) {
  const t = {
    position: "absolute",
    top: e.top || "0px",
    left: e.left || "0px",
    border: "none",
    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 2px"
  };
  return /* @__PURE__ */ J.jsx(
    "input",
    {
      style: t,
      className: e.class,
      type: "button",
      id: e.id,
      value: e.value,
      onClick: e.onClick
    }
  );
}
var j = /* @__PURE__ */ ((e) => (e.PropertyInfo = "propertyinformation", e.Planinformasjon = "planinformation", e.ShowArealplaner = "show-arealplaner", e.ToggleArealplaner = "toggle-arealplaner", e))(j || {});
const Hr = "Arealplaner", Wr = (e) => {
  let t = `${e.gardsnr}/${e.bruksnr}`;
  return e.festenr && (t += `/${e.festenr}`), e.seksjonsnr && (t += `/${e.seksjonsnr}`), t;
}, Ur = (e, t, r, n) => ({
  selected: !0,
  name: e,
  address: t.adresse || "",
  postalCode: "",
  postalArea: "",
  x: r.x,
  y: r.y,
  wkid: n.spatialReference.wkid ?? void 0,
  source: "mapClick",
  matrikkelEnhet: {
    gardsnr: t.gardsnr,
    bruksnr: t.bruksnr,
    festenr: t.festenr,
    seksjonsnr: t.seksjonsnr,
    kommunenr: String(t.kommunenr),
    kommunenavn: t.kommunenavn
  }
}), Br = (e, t, r) => `Grunneiendom ${e} i ${t || ""} kommune (${r || ""})`, Gr = (e) => {
  if (!(e.gardsnr === void 0 || e.bruksnr === void 0))
    return {
      gardsnr: Number(e.gardsnr),
      bruksnr: Number(e.bruksnr),
      festenr: e.festenr ? Number(e.festenr) : void 0,
      seksjonsnr: e.seksjonsnr ? Number(e.seksjonsnr) : void 0,
      kommunenr: String(e.kommunenr),
      kommunenavn: String(e.kommunenavn)
    };
};
var Yr = /* @__PURE__ */ ((e) => (e.PLAN_ID = "PLANID", e.PLAN_NAVN = "PLANNAVN", e.PLAN_TYPE = "PLANTYPE", e.PLAN_STATUS = "PLANSTAT", e.PLAN_BESTEMMELSER = "PLANBEST", e.IKRAFTTREDELSESDATO = "IKRAFT", e.LOVREFERANSE = "LOVREFERANSE", e.PLAN_REGISTER_LINK = "PLANREGISTERLINK", e.VERTIKALNIVÅ = "VERTNIV", e.OBJTYPE = "OBJTYPE", e))(Yr || {});
const ci = we("popupUtils"), li = (e, t) => !e || e === "null" ? t === "Eiendom" ? "" : "Eiendommen har flere adresser" : `Tilknyttet adresse: ${e}`, Kr = (e, t, r, n, i) => {
  const a = li(t, n), c = "Benytt knappene i verktøylinjen for å se matrikkelinformasjon om eiendommen og alle arealplaner som berører eiendommen";
  return e ? !r || Object.keys(r).length === 0 ? `
        <div style="font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, 'Helvetica Neue', sans-serif; padding: 1rem; background-color: #f9f9f9; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
          <div style="font-size: 1.1rem; font-weight: 600; color: #333; margin-bottom: 8px;">${i}</div>
          <div style="font-size: 0.9rem; font-weight: 600; color: #333; margin-bottom: 8px;">${a}</div>
          <div style="font-size: 0.9rem; font-weight: 600; color: #333; margin: 12px 0 8px 0;">Finner ingen arealplaner i kartet</div>
          <div style="font-size: 0.75rem; color: #666; line-height: 1.4;">${c}</div>
        </div>
        ` : `
    <div style="font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, 'Helvetica Neue', sans-serif; padding: 1rem; background-color: #f9f9f9; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
        <div style="font-size: 1.1rem; font-weight: 600; color: #333; margin-bottom: 8px;">${i}</div>
        <div style="font-size: 0.9rem; font-weight: 600; color: #333; margin-bottom: 8px;">${a}</div>
        <div style="font-size: 0.9rem; font-weight: 600; color: #333; margin: 12px 0 8px 0;">Arealplaner vist i kartet</div>
  
      <div>
        ${Object.entries(r).map(([s, l]) => {
    const u = l.attributes.PLANNAVN;
    return `
            <div style="margin: 0.5rem 0; padding: 0.5rem; background-color: white; border-radius: 4px; box-shadow: 0 1px 2px rgba(0,0,0,0.05); border: 1px solid #eee;">
              <div style="display: flex; align-items: center; justify-content: space-between; font-size: 0.9rem; color: #333;">
                <div>
                  <a href="${l.attributes.PLANREGISTERLINK}" target="_blank" style="color: #0066cc; text-decoration: none; font-weight: 500; border-bottom: 1px solid #0066cc;">${u ? `${u} (${s})` : s}</a>
                </div>
              </div>
            </div>
          `;
  }).join("")}
      </div>
    <div style="margin-top: 12px; font-size: 0.75rem; color: #666; line-height: 1.4;">${c}</div>
    </div>
  ` : `
        <div style="font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, 'Helvetica Neue', sans-serif; padding: 1rem; background-color: #f9f9f9; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
          <div style="font-size: 1.1rem; font-weight: 600; color: #333; margin-bottom: 8px;">En feilsituasjon har oppstått, prøv igjen senere</div>
        </div>
        `;
}, ui = (e, t) => {
  const r = e.graphic.attributes[Yr.PLAN_ID];
  if (r) {
    t[r] || (t[r] = { PLANID: r, attributes: {} });
    for (const [n, i] of Object.entries(e.graphic.attributes))
      t[r].attributes[n] = i;
  }
  return t;
}, di = (e) => e.reduce(
  (t, r) => ui(r, t),
  {}
), fi = (e) => e.filter(
  (t) => t.layer.type === "vector-tile" && t.type === "graphic"
), Jr = async (e, t) => {
  try {
    const r = await e.hitTest(t);
    if (r.results.length) {
      const n = fi(r.results);
      return di(n);
    }
  } catch (r) {
    ci.error(r.message);
  }
}, We = (e) => e.map?.allLayers.find((t) => t.title === Hr), xt = (e, t) => e.popup?.actions.find((r) => r.id === t), pi = (e, t) => {
  if (e.map)
    for (const r of e.map.allLayers)
      r.parent && "title" in r.parent && r.parent.title === t && (r.visible = !0);
}, mi = (e, t) => {
  let r = e.adresseid || e.Match_addr, n = e.Match_addr, i = "";
  return e.gatenavn && (i = `${e.gatenavn} ${e.husnrbokstav}`, n = `${i}, ${e.postnr} ${e.poststed}`), {
    selected: !0,
    id: r,
    name: n,
    address: i,
    postalCode: e.postnr || "",
    postalArea: e.poststed || "",
    x: e.x,
    y: e.y,
    wkid: 25833,
    matrikkelEnhet: t
  };
}, yi = we("widgetUtils"), hi = (e) => {
  e.ui.find("location-analytics-fullscreen") || e.ui.add(new Yn({
    id: "location-analytics-fullscreen",
    view: e
  }), { position: "top-right" });
}, gi = async (e) => {
  try {
    const t = await e.takeScreenshot(), n = await (await fetch(t.dataUrl)).blob();
    await navigator.clipboard.write([
      new ClipboardItem({
        [n.type]: n
      })
    ]);
  } catch (t) {
    yi.error("Failed to copy screenshot to clipboard:", t);
  }
}, vi = (e) => {
  if (!e.ui.find("location-analytics-copymap")) {
    const r = document.createElement("input");
    r.id = "location-analytics-copymap", r.type = "button", r.className = "esri-component esri-widget--button esri-widget esri-interactive", r.onclick = () => gi(e), e.ui.add(r, { position: "top-right" });
  }
}, bi = (e) => {
  e.ui.find("location-analytics-basemaps") || e.ui.add(new ze({
    id: "location-analytics-basemaps",
    view: e,
    content: new Hn({
      view: e,
      source: ge
    }),
    expandTooltip: "Bakgrunnskart",
    autoCollapse: !0,
    closeOnEsc: !0
  }), { position: "bottom-left" });
}, _i = (e, t) => {
  if (!e.ui.find("location-analytics-measure")) {
    const n = new ze({
      id: "location-analytics-measure",
      view: e,
      content: e.type === "3d" ? new Un({ view: e }) : new Wn({ view: e })
    });
    e.ui.add(n, { position: "top-right" }), Z.when(() => n.expanded === !1, () => {
      n.content.viewModel.clear();
    });
    const i = Z.watch(() => n.expanded, (a) => {
      a ? t(!0) : (t(!1), n.content.viewModel.clear());
    });
    n.addHandles(i);
  }
}, Ei = (e) => {
  if (!e.ui.find("location-analytics-daylight") && e.type === "3d") {
    const r = new ze({
      id: "location-analytics-daylight",
      view: e,
      content: new Bn({
        view: e
      })
    });
    e.ui.add(r, { position: "top-right" });
  }
}, wi = (e) => {
  if (!e.ui.find("location-analytics-shadow") && e.type === "3d") {
    const r = new ze({
      id: "location-analytics-shadow",
      view: e,
      expandIcon: "measure-building-height-shadow"
    });
    e.ui.add(r, { position: "top-right" }), Z.watch(() => r.expanded, (n) => {
      n ? r.content = new Gn({
        view: e
      }) : r.content && r.content.destroy();
    });
  }
}, Si = (e) => {
  e.ui.find("location-analytics-scalebar") || e.ui.add(new Kn({
    view: e,
    unit: "metric"
  }), { position: "bottom-left" });
}, ki = (e, t) => {
  e.popup?.actions.push(new Ne({
    title: t("popup.property"),
    id: j.PropertyInfo,
    icon: "locator"
  })), e.popup?.actions.push(new Ne({
    title: "Arealplaner for eiendommen",
    id: j.Planinformasjon,
    icon: "classify-objects"
  }));
}, Ri = (e) => {
  const t = We(e), r = t?.visible ?? !1;
  if (e.popup?.actions.push(new Ne({
    title: "Arealplaner",
    id: j.ToggleArealplaner,
    icon: r ? "view-visible" : "view-hide"
  })), e.popup?.actions.push(new Ne({
    title: "Vis alle arealplaner",
    id: j.ShowArealplaner,
    icon: "show-multiple-layers-at-a-time"
  })), t) {
    const n = Z.watch(
      () => t.visible,
      (i) => {
        const a = xt(e, j.ToggleArealplaner);
        a && (a.icon = i ? "view-visible" : "view-hide");
      }
    );
    e.addHandles(n, "arealplaner-visibility");
  }
}, Ci = (e) => {
  const t = Z.on(
    () => e.popup,
    "open",
    () => {
      const n = We(e);
      if (n) {
        const i = xt(e, j.ToggleArealplaner);
        i && (i.icon = n.visible ? "view-visible" : "view-hide");
      }
    }
  );
  e.addHandles(t, "location-analytics");
  const r = Z.on(
    () => e.popup,
    "close",
    () => {
      e.removeHandles("arealplaner-visibility");
    }
  );
  e.addHandles(r, "location-analytics");
}, Ti = (e, t, r, n) => {
  const i = We(e);
  if (!i)
    return !1;
  const a = i.visible;
  return i.visible = !a, t.action.title = "Arealplaner", t.action.icon = a ? "view-hide" : "view-visible", r ? (e.popup?.close(), n(e, r, !1), !0) : !1;
}, xi = (e, t, r) => {
  const n = We(e);
  if (!n)
    return !1;
  pi(e, Hr), n.visible = !0;
  const i = xt(e, j.ToggleArealplaner);
  return i && (i.title = "Arealplaner", i.icon = "view-visible"), t ? (e.popup?.close(), r(e, t, !1), !0) : !1;
}, fe = we("mapUtils"), Oi = async (e, t, r, n, i) => {
  const a = e.matrikkelInfo, c = Wr(a), s = a.adresse || e?.address || "", l = Br(c, a.kommunenavn, a.kommunenr);
  if (i) {
    const f = Ur(c, a, t, r);
    i(f);
  }
  const u = await Jr(r, n);
  return { matrikkelEnhet: c, adresse: s, heading: l, planer: u };
}, Di = async (e, t, r, n, i, a) => {
  const c = a ? a.getMatrikkelEnhetFromGeometry(e) : Promise.resolve([]), s = Jr(t, r), l = await Promise.allSettled([c, s]), u = l[0], f = l[1];
  let m = "", g = n?.address || "", h = n?.name || "Resultat", y;
  if (u.status === "fulfilled" && u.value.length > 0) {
    const v = u.value[0];
    if (m = Wr(v), g = v.adresse || g, h = Br(m, v.kommunenavn, v.kommunenr), i) {
      const O = Ur(m, v, e, t);
      i(O);
    }
  } else
    n && (m = n.name || "");
  return f.status === "fulfilled" && (y = f.value), { matrikkelEnhet: m, adresse: g, heading: h, planer: y };
}, Ot = async (e, t, r, n, i, a, c) => {
  try {
    let s;
    n?.matrikkelInfo ? s = await Oi(
      n,
      t,
      e,
      r,
      a
    ) : s = await Di(
      t,
      e,
      r,
      n,
      a,
      c
    );
    const { matrikkelEnhet: l, adresse: u, heading: f, planer: m } = s;
    return i || e.openPopup({
      title: "Resultat fra søk",
      content: Kr(l, u, m, n?.searchType, f),
      location: t
    }), { matrikkelEnhet: l, adresse: u, planer: m };
  } catch (s) {
    throw fe.error("Feil under behandling av lokasjon:", s), s;
  }
}, Et = (e, t, r, n, i) => {
  const a = e.on("click", function(c) {
    if (n())
      return;
    const l = document.getElementById("origo-map-container");
    l && (l.style.cursor = "wait"), Ot(
      e,
      c.mapPoint,
      c,
      void 0,
      t,
      r,
      i
    ).catch((u) => {
      fe.error("Feil under behandling av klikk:", u);
    }).finally(() => {
      l && (l.style.cursor = "default");
    });
  });
  e.addHandles(a, "location-analytics");
}, mr = async (e, t, r) => {
  if (r)
    return;
  const n = new wr({
    x: t.x,
    y: t.y,
    spatialReference: { wkid: t.wkid || e.spatialReference.wkid }
  }), i = e.toScreen(n);
  if (!i) {
    fe.error("Kunne ikke konvertere punkt til skjermkoordinater");
    return;
  }
  try {
    await Ot(
      e,
      n,
      i,
      {
        name: t.name,
        address: t.address,
        matrikkelInfo: t.matrikkelEnhet ? {
          gardsnr: t.matrikkelEnhet.gardsnr,
          bruksnr: t.matrikkelEnhet.bruksnr,
          festenr: t.matrikkelEnhet.festenr,
          seksjonsnr: t.matrikkelEnhet.seksjonsnr,
          kommunenr: t.matrikkelEnhet.kommunenr || "",
          kommunenavn: t.matrikkelEnhet.kommunenavn || ""
        } : void 0
      },
      r
    );
  } catch (a) {
    fe.error("Feil under åpning av popup:", a);
  }
}, Mi = (e) => e?.includes(j.PropertyInfo) ?? !1, yr = (e, t, r, n, i, a = !1) => {
  Z.when(() => e.popup?.actions, () => {
    const s = e.popup?.actions.filter(
      (l) => l.id === j.PropertyInfo || l.id === j.Planinformasjon || l.id === j.ShowArealplaner
    );
    s && s.length > 0 || (e.popup?.viewModel && (e.popup.viewModel.includeDefaultActions = !1), e.popup && (e.popup.dockOptions.position = "bottom-right"), Mi(t) && ki(e, i), a || Ri(e));
  }), a || Ci(e);
  const c = Z.on(
    () => e.popup,
    "trigger-action",
    (s) => {
      if (s.action.id === j.PropertyInfo)
        r({ widgetId: j.PropertyInfo, keepOpen: !0, layoutPosition: "left" });
      else if (s.action.id === j.Planinformasjon)
        r({ widgetId: j.Planinformasjon, keepOpen: !0, layoutPosition: "left" });
      else if (!a && s.action.id === j.ToggleArealplaner) {
        if (Ti(e, s, n(), mr))
          return;
      } else if (!a && s.action.id === j.ShowArealplaner && xi(e, n(), mr))
        return;
      e.popup?.close();
    }
  );
  e.addHandles(c, "location-analytics");
}, Pi = (e, t, r, n) => {
  n || e.openPopup({
    title: "Søkeresultat",
    content: Kr(t),
    location: r
  });
}, Ni = (e, t, r, n, i, a) => {
  const c = e.toScreen(t);
  if (!c)
    return;
  const s = Gr(r), l = s ? {
    ...s,
    adresse: i
  } : void 0;
  Ot(
    e,
    t,
    c,
    {
      name: n,
      address: i,
      isSearchResult: !0,
      searchType: r.Addr_type,
      matrikkelInfo: l
    },
    a
  ).catch((u) => {
    fe.error("Feil under behandling av søkeresultat:", u);
  });
}, hr = (e, t, r = !1, n = !1) => {
  const i = e.ui.find("location-analytics-search");
  if (r) {
    i && e.ui.remove(i);
    return;
  } else if (i)
    return;
  const a = new $n({
    id: "location-analytics-search",
    view: e,
    sources: [ni, oi],
    includeDefaultSources: !1,
    locationEnabled: !1
  });
  e.ui.add(a, { position: "top-right", index: 0 });
  const c = a.on("select-result", function(s) {
    const l = s.result.feature.attributes, u = Gr(l), f = mi(l, u);
    if (t(f), l.Addr_type === "Stedsnavn") {
      Pi(e, f.name, s.result.feature.geometry, n);
      return;
    }
    Ni(
      e,
      s.result.feature.geometry,
      l,
      f.name,
      f.address,
      n
    );
  });
  a.addHandles(c, "location-analytics");
}, gr = (e, t, r) => {
  t && (t.includes("fullscreen") && hi(e), t.includes("copymap") && vi(e), t.includes("basemaps") && bi(e), t.includes("measure") && _i(e, r), t.includes("daylight") && Ei(e), t.includes("shadow") && wi(e), t.includes("scalebar") && Si(e));
}, vr = (e, t) => {
  if (t)
    for (const r of t) {
      const n = e.ui.find("location-analytics-" + r);
      if (n) {
        e.ui.remove(n);
        try {
          n.destroy();
        } catch (i) {
          fe.warn(`Failed to destroy widget ${r}:`, i);
        }
      }
    }
}, br = (e) => {
  e.popup && (e.popup.dockEnabled = !0, e.popup.dockOptions = {
    buttonEnabled: !0,
    breakpoint: !0,
    position: "bottom-right"
  });
}, ut = we("Map");
function La(e) {
  const { t } = On("map"), {
    disableMapClick: r,
    selectedLocation: n,
    setDisableMapClick: i,
    setSelectedLocation: a
  } = Fr(), c = Q(null), s = Q(r);
  $(() => {
    s.current = r;
  }, [r]);
  const {
    mapView: l,
    sceneView: u,
    mapMode: f,
    toggleMapMode: m,
    setMapView: g,
    setSceneView: h
  } = to();
  ai({
    containerRef: c,
    mapMode: f,
    webMapId: e.webMapId,
    webSceneId: e.webSceneId,
    disablePopup: e.disablePopup,
    initialView: e.initialView,
    onMapViewCreated: g,
    onSceneViewCreated: h
  }), $(() => {
    e.disable3D && f === Ae.ThreeD && m();
  }, [e.disable3D, f, m]), $(() => (c.current && l?.map && (l.map.basemap = $r), () => {
  }), [c.current, l]), $(() => {
    if (ut.debug("MapView setup effect, mapView ready:", !!l), !!l)
      return br(l), hr(
        l,
        a,
        e.disableSearch,
        e.disablePopup
      ), gr(l, e.tools2D, i), e.disableClick || (ut.debug("Adding view click handler"), Et(
        l,
        e.disablePopup,
        a,
        () => s.current,
        e.matrikkelClient
      )), e.widgetItems && e.onActiveWidgetChange && yr(
        l,
        e.widgetItems.map((v) => v.widget),
        e.onActiveWidgetChange,
        () => n ?? void 0,
        t,
        !0
      ), () => {
        ut.debug("Cleaning up mapView"), l.removeHandles("location-analytics"), e.tools2D && vr(l, e.tools2D);
      };
  }, [
    l,
    e.disableSearch,
    e.disablePopup,
    e.disableClick,
    e.tools2D,
    e.matrikkelClient,
    a,
    i,
    t
  ]), $(() => (u && (br(u), hr(
    u,
    a,
    e.disableSearch,
    e.disablePopup
  ), gr(u, e.tools3D, i), Et(
    u,
    e.disablePopup,
    a,
    () => s.current,
    e.matrikkelClient
  ), e.widgetItems && e.onActiveWidgetChange && yr(
    u,
    e.widgetItems.map((v) => v.widget),
    e.onActiveWidgetChange,
    () => n ?? void 0,
    t,
    !0
  )), () => {
    u && (u.removeHandles("location-analytics"), e.tools3D && vr(u, e.tools3D));
  }), [
    u,
    e.disableSearch,
    e.disablePopup,
    e.tools3D,
    e.widgetItems,
    e.onActiveWidgetChange,
    a,
    i,
    t
  ]);
  const y = () => {
    m();
  };
  return /* @__PURE__ */ J.jsxs("div", { className: "map-container", children: [
    /* @__PURE__ */ J.jsx("div", { id: "origo-map-container", className: "esri-map-container", ref: c }),
    !e.disable3D && /* @__PURE__ */ J.jsxs(J.Fragment, { children: [
      /* @__PURE__ */ J.jsx(
        si,
        {
          top: "10px",
          left: "55px",
          class: "esri-component esri-widget--button esri-widget esri-interactive",
          id: "map-mode-toggle-button",
          value: f === Ae.TwoD ? "3D" : "2D",
          onClick: y
        }
      ),
      /* @__PURE__ */ J.jsx(Dn, { referenceElement: "map-mode-toggle-button", placement: "right", children: t("toggleModeTooltip") })
    ] }),
    e.children
  ] });
}
const Va = (e, t, r) => {
  const { disableMapClick: n, setSelectedLocation: i } = Fr(), a = Q(() => n);
  $(() => {
    a.current = () => n;
  }, [n]), $(() => {
    if (e)
      return Et(
        e,
        t,
        i,
        () => a.current(),
        // Always get fresh value
        r
      ), () => {
        e.removeHandles("location-analytics");
      };
  }, [e, t, i, r]);
};
let _r = !1;
function za(e) {
  if (_r)
    return;
  _r = !0;
  const t = () => {
    e.hasResourceBundle(e.language, "map") && ii(e);
  };
  e.isInitialized && t(), e.on("initialized", t), e.on("languageChanged", t), e.on("loaded", t);
}
const Ai = "Toggle between 2D and 3D view", Ii = {
  basis: "Standard",
  graatone: "Grayscale",
  bilder: "Imagery",
  mork: "Dark"
}, ji = {
  placeholder: "Address or place..."
}, Li = {
  huff: "Establishment analysis",
  property: "Property info",
  analysis: "Analysis area",
  streetview: "StreetView"
}, Vi = {
  filterPlaceholder: "Search for map layers..."
}, zi = {
  toggleModeTooltip: Ai,
  basemaps: Ii,
  search: ji,
  popup: Li,
  layerlist: Vi
}, Fi = "Bytt mellom 2D- og 3D-visning", $i = {
  basis: "Fargekart",
  graatone: "Gråtone",
  bilder: "Bilder",
  mork: "Mørkt"
}, Hi = {
  placeholder: "Adresse eller sted..."
}, Wi = {
  huff: "Etableringsanalyse",
  property: "Eiendomsinformasjon",
  analysis: "Analyseområde",
  streetview: "Gatebilder"
}, Ui = {
  filterPlaceholder: "Søk etter kartlag..."
}, Bi = {
  toggleModeTooltip: Fi,
  basemaps: $i,
  search: Hi,
  popup: Wi,
  layerlist: Ui
}, Fa = {
  nb: {
    map: Bi
  },
  en: {
    map: zi
  }
};
export {
  La as Map,
  Ae as MapMode,
  j as MapPopupActions,
  si as MapTool,
  ka as MapViewProvider,
  Pa as addToLocationHistory,
  Et as addViewClickHandler,
  ge as basemaps,
  br as configurePopup,
  za as initMapContext,
  Vr as mapSlice,
  Fa as mapTranslation,
  Ta as secondaryPolygonSymbol,
  zr as selectDisableMapClick,
  Ia as selectLocationHistory,
  Zo as selectSelectedLocation,
  Ca as selectedPointSymbol,
  Ra as selectedPolygonSymbol,
  Qo as setDisableMapClick,
  Aa as setHighlightGeometries,
  Xo as setSelectedLocation,
  ii as updateBasemapTitles,
  ja as useDisableMapClick,
  Va as useMapClickHandler,
  Fr as useMapState,
  to as useMapViewContext
};
//# sourceMappingURL=index.mjs.map
